import { render, staticRenderFns } from "./company-metadata-main.vue?vue&type=template&id=02934540&scoped=true&lang=pug"
import script from "./company-metadata-main.vue?vue&type=script&lang=ts"
export * from "./company-metadata-main.vue?vue&type=script&lang=ts"
import style0 from "./company-metadata-main.vue?vue&type=style&index=0&id=02934540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02934540",
  null
  
)

export default component.exports